import { doFetch } from "./fetcher";

const Backtest = {
  // Get
  getBacktest: (id, benchmark, rtype = "BACKTEST") =>
    doFetch(
      `/ajax_backtest/?scenario_id=${id}&rtype=${rtype}&benchmark=${benchmark}`
    ),
  // reset get backtest
  getBacktestReload: (id, benchmark, rtype = "BACKTEST") =>
    doFetch(
      `/ajax_backtest/?scenario_id=${id}&rtype=${rtype}&benchmark=${benchmark}&reload=Y`
    ),
  getMetrics: (id, rtype = "BACKTEST") =>
    doFetch(`/ajax_get_perf_hist_metrics/?scenario_id=${id}&rtype=${rtype}`),
  getPerfHistMetrics: (id, rtype = "BACKTEST") =>
    doFetch(`/ajax_get_perf_hist_metrics/?scenario_id=${id}&rtype=${rtype}`),
  getRiskStatistics: (id, rtype = "BACKTEST") =>
    doFetch(`/ajax_get_risk_statistics/?scenario_id=${id}&rtype=${rtype}`),
  getScenarios: () => doFetch("/ajax_get_scenarios/"),
  getSearchCriteria: () => doFetch("/ajax_search_criteria/"),
  getLivePortfolios: () => doFetch("/ajax_get_live_portfolios/"),
  getPredefinedScenarios: () => doFetch("/ajax_get_predefined_scenarios/"),

  getScenariosNew: (rtype) => doFetch(`/ajax_get_scenarios/?rtype=${rtype}`),

  // get client portfolio scenario
  getScenarioClient: () => doFetch(`ajax_get_scenarios/?rtype=COMPARE`),

  // getPerfHistMetricsLive: (id, rtype = 'LIVE') => doFetch(`/ajax_get_perf_hist_metrics/?scenario_id=${id}&rtype=${rtype}`),
  // getBacktestCurrent: (id, benchmark, rtype = 'CURRENT') => doFetch(`/ajax_backtest/?scenario_id=${id}&rtype=${rtype}&benchmark=${benchmark}`),
  // new post req
  comparePortfolio: (data) => doFetch("/ajax_compare_portfolio/", "POST", data),

  // compare portfolio autosuggestion
  getAutocomplete: (txt) =>
    doFetch(`/ajax_get_company_name/?starting_chars=${txt}`),

  // get auto complete benchmarks
  getAutocompleteBenchmarks: (txt) =>
    doFetch(`/ajax_get_company_name/?starting_chars=${txt}&type=BENCHMARK`),

  getGoalsScenarios: (
    investment_objective,
    age = "",
    initial_investment = "",
    monthly_installment = "",
    years_number = ""
  ) =>
    doFetch(
      `/ajax_get_goals_scenarios/?investment_objective=${investment_objective}&age=${age}&initial_investment=${initial_investment}&monthly_installment=${monthly_installment}&years_number=${years_number}`
    ),
  getMontecarlo: (
    id,
    initial_investment = 100000,
    inc = 10000,
    num_years = 10
  ) =>
    doFetch(
      `/ajax_get_montecarlo_data/?scenario_id=${id}&initial_investment=${initial_investment}&increment=${inc}&num_years=${num_years}`
    ),
  getScenarioShortlist: (id, ptype) =>
    doFetch(
      `/ajax_get_scenario_shortlist_symbols/?scenario_id=${id}&portfolio_type=${ptype}`
    ),
  getScenarioLimits: (id) =>
    doFetch(`/ajax_get_scenario_limits/?scenario_id=${id}`),
  getScenarioGuardrails: (id) =>
    doFetch(`/ajax_get_scenario_guardrails/?scenario_id=${id}`),

  // Create
  createPortfolio: (data) => doFetch("/ajax_create_portfolio/", "POST", data),
  createPortfolioAssetAllocations: (data) =>
    doFetch("/ajax_create_asset_allocation/", "POST", data),
  login: (data) => doFetch("/auth-jwt/", "POST", data),
  compare: (data) => doFetch("/ajax_compare_portfolio/", "POST", data),

  // create-client-portfolio
  createClientPortfolio: (data) =>
    doFetch("/ajax_create_client_portfolio/", "POST", data),

  // posting myUniverse
  postMyUniverse: (data) =>
    doFetch("/ajax_save_client_universe/", "POST", data),
  // get myUniverse
  getMyUniverse: () => doFetch(`/ajax_get_client_universe/`),

  // simulation stress test res
  getStressTest: ({ id, rtype, dt, cid }) =>
    doFetch(
      `/ajax_get_stress_test_results/?scenario_id=${id}&rtype=${rtype}&dt=${dt}&client_portfolio_id=${cid}`
    ),
  getUserPreferences: () => doFetch("/ajax_get_user_preferences/"),

  //clients
  getClients: () => doFetch("/ajax_get_clients/"),
};

export default Backtest;



// WEBPACK FOOTER //
// ./src/service/backtest.service.js